import { render, staticRenderFns } from "./tsjTestTable.vue?vue&type=template&id=e5c9a61a&scoped=true&"
import script from "./tsjTestTable.vue?vue&type=script&lang=js&"
export * from "./tsjTestTable.vue?vue&type=script&lang=js&"
import style0 from "./tsjTestTable.vue?vue&type=style&index=0&id=e5c9a61a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c9a61a",
  null
  
)

export default component.exports